import React, { useState } from "react"
import Button from "../lds/Button";

function ListFeedPanel(props) {
  const { list_id, linked_to_feed, list_type } = props;

  const [creatingFeed, setCreatingFeed] = useState(false)

  const onCreateFeed = async () => {
    try {
      setCreatingFeed(true)

      const response = await fetch(`/feeds/${list_id}/create_feed_for_list`, {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").getAttribute("content"),
        }
      })

      if (response.status==403) {
        const { max_feeds, user_feeds_count } = await response.json()
        LegacyModalService.openModal(MaxFeedsErrorModal, {
          maxFeedCount: max_feeds,
          currentFeedCount: user_feeds_count,
          reloadAction: onCreateFeed,
        });
      } else {
        const feedCreateModalHtml = await response.text()
        LegacyModalService.openModal(LDSFeedSaveModal, {
          legacyModalContent: feedCreateModalHtml,
        });
      }
    } catch(e) {
      throw e;
    } finally {
      setCreatingFeed(false)
    }
  }

  return <>
    <div className="buttonGroup-small list_feed_panel_buttons">
      { list_type == "Companies" && <MapViewButton list_id={list_id} /> }

      <span>&nbsp;</span>
      { !linked_to_feed && (
        <Button
          size="small"
          variant="primary"
          id="create_a_feed_from_a_list"
          className="button-small button-primary"
          onClick={onCreateFeed}
        >
          { creatingFeed ? "Creating feed" : "Save Feed" }
        </Button>
      )}
      <span>&nbsp;</span>

      { linked_to_feed ? <ViewFeedButton {...props} /> : <ViewActivityButton {...props} /> }
    </div>
  </>
}


const MapViewButton = ({ list_id }) => {
  const click_action = function(e){
    e.preventDefault();

    window.location.href = `/mapping?query=&category=all_event&time_select=time_any&user_list_id=${list_id}`;
  }

  return (
    <button id="search_via_map" onClick={click_action} className="button-small button-primary" title="Display the activity for all the companies on this list in a map view">View on Map</button>
  );
}

var ViewFeedButton = (props) => {
  const click_action = function(e){
    e.preventDefault();
    window.location.assign("/feeds/" + props.feed_id + "/display_saved_feed");
  }

  return(
    <button id="see_a_feed_from_a_list" onClick={click_action} className="button-small button-primary" title="View the feed of activity for all the companies on this list">See Activity Feed</button>
  );
}

var ViewActivityButton = (props) => {
  let list_type = String(props.list_type);
  const click_action = function(e){
    e.preventDefault();

    var url = `/facet_search?user_list_id=${props.list_id}&category=all_event&time_select=time_any`;

    if(props.is_crm_list){
      url = "/facet_search?relationships%5B%5D=crm&category=all_event&time_select=time_any"
    }
    window.location.assign(url);
  }
  return(
    <button id="view_list_activity" onClick={click_action} className="button-primary button-small" title={`View the activity for all the ${list_type.toLowerCase()} on this list in a timeline view`}>Search {list_type} for Activity</button>
  );
}


window.ListFeedPanel = ListFeedPanel;
export default ListFeedPanel;
